
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import FormModelDisplay from '@/components/FormModelDisplay.vue';
import EmbeddedForm from '@/util/form/EmbeddedForm';
import WeeklySignRepository from '@/repositories/WeeklySign/WeeklySignRepository';
import WeeklySignTranslationRepository from '@/repositories/WeeklySign/WeeklySignTranslationRepository';

@Component({
    components: {
        GeneralScaffold,
        FormModelDisplay,
    },
})
export default class WeeklySignFormScreen extends Vue {
    @Inject()
    private readonly weeklySignRepository!: WeeklySignRepository;

    @Inject()
    private readonly weeklySignTranslationRepository!: WeeklySignTranslationRepository;

    private get embeds(): EmbeddedForm[] {
        return [
            {
                relationship: 'translations',
                parentRefKey: 'weeklySignId',
                i18nGroup: 'weeklySignTranslation',
                entityRepository: this.weeklySignTranslationRepository,
                columns: ['lang', 'name'],
            },
        ];
    }
}
